export default {
  state(state, edroneContext) {
    state.isDemo = edroneContext.isDemo;
    state.trackerId = edroneContext.trackerId;
    state.appId = edroneContext.appId;
    state.timezone = edroneContext.timezone;
    state.user = {
      ...edroneContext.user,
      name: `${edroneContext.user.firstName} ${edroneContext.user.lastName}`,
      avatar: edroneContext.user.avatar
        ? `https://dgk28ckagqims.cloudfront.net/avatars/${edroneContext.user.avatar}`
        : "https://d3vhsxl1pwzf0p.cloudfront.net/images/static/no_fb.jpg",
    };
    state.tracker = edroneContext.tracker;
    state.isMobile = document.documentElement.clientWidth < 992;
  },
  setLoadingOverlay(state, isVisible) {
    state.layout.isLoadingOverlayVisible = isVisible;
  },
  setMenuPinned(state, pinned) {
    state.pinned = pinned;
  },
  setIsMobile(state, isMobile) {
    state.isMobile = isMobile;
  },
};
